module.exports = __webpack_public_path__ + "static/media/CF.e6e678ef.png";